import React, { useEffect, useState, Fragment } from "react";
import WebDesigner, { EditorMode, SaveState, SaveType } from "../WebDesigner";
import { EditorState } from "../EditorTypes";
import { SiteData } from "../Data/SiteData";
import AddEditlayoutPopup from "../../LayoutList/AddEditlayoutPopup";
import ReactDom, { unmountComponentAtNode } from "react-dom";
import AddEditStylePopup from "components/Style/AddEditStylePopup";
import { utils, ResponseCode, LoginUserType,AddLogInAmplitude} from "utils/Utils";
import { AsyncAjaxGet, AsyncAjaxPost } from "components/Common/AsyncAjaxService";
import VGPopUp from "components/Controls/VGPopUp";
import { useSelector, useDispatch } from 'react-redux'
import {
  ActivateWB
} from '../../Slice/Business';
import HoverToolTip from "../HoverToolTip";
import SelectDropdown from "../SelectDropdown";
import { SaveHistory } from "../Utilities/PageDataHandler";
import Toast from "../Toast";
import Multilocation from "components/Multilocation/Multilocation";
import { MultiLocationLive } from "components/Multilocation/MulitLocationLIve";
import { ArchivePost, BlogPostStatus } from "vagaro-website-rendering/src/components/Utilities/BlogAPI";
import { AlertConfirm } from "../ConfirmationPopups";





export default function SaveAndPublishMenu({
  designer,
  inSaveState,
}: {
  designer: WebDesigner;
  inSaveState: SaveState;
}) {
  let saveIcon = null;
  let saveColor = "#3E8438";
  let saveText = "Saved";




  designer.updateSaveState = (state: SaveState) => {
    setSaveState(state);

  }



  const [saveState, setSaveState] = useState(inSaveState);

  const canModify = designer.props.siteData.isModifyAllowed

  if(!canModify){
    saveText = "View Only Mode";
    saveColor = "#888"
    saveIcon = <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512" style={{marginRight:"2px"}} fill="#888"><path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"/></svg>
  }
  else{
    switch (saveState) {
      case SaveState.Success:
        saveIcon = <SavedSuccesfullIcon />;
        break;
      case SaveState.InProgress:
        saveIcon = <SaveInProgressIcon />;
        saveColor = "#6D6E6F";
        saveText = "Saving";
        break;
      case SaveState.Error:
        saveIcon = <SavedErrorIcon />;
        saveColor = "#B42318";
        saveText = "Unsaved"
        break;
      case SaveState.Unsaved:
        saveIcon = <UnsavedIcon />;
        saveColor = "#6D6E6F";
        saveText = "Unsaved";
        break;
      default:
        saveText = "?";
    }
  }


  const appendText = (designer.saveType == SaveType.All)?"":
  (designer.saveType == SaveType.Layout)?" Layout":" Style"

  saveText+=appendText;

  return (
    <div
      className="flex-row top-right-menu row-gap-med"
      style={{
        color: "#333333",
        position: "absolute",
        top: "0",
        right: "0",
        paddingRight: "10px",
        height: "49px",
        background: "#fff",

        whiteSpace:'nowrap'
      }}
    >      <button

    style={{marginLeft:"8px"}}
        // {...CreateToolTip("Toggle Layout Mode",true)}
        className="invisible-button"
        onClick={() => {
          designer.toggleLayoutMode();
        }}
      >
        <div style={{ opacity: designer.state.layoutMode ? 1 : 0.3 }}  className={designer.state.layoutMode?"layout-checked":""}>
          {designer.state.layoutMode ? <LayoutIconChecked /> : <LayoutIcon />}
        </div>

        <HoverToolTip text="X-Ray Mode" />
      </button>


      <div className="center-all">
      <svg xmlns="http://www.w3.org/2000/svg" style={{marginRight:"-4px"}} height="1em" viewBox="0 0 512 512" fill="#333"><path d="M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"/></svg>
             <SelectDropdown options={[

              {label:"100%",value:"1"},
              {label:"75%",value:".75"},
              {label:"50%",value:".5"},
            ]} defaultValue={"1"} onChange={(val:string)=>{

              let num = parseFloat(val);
              if(num){
                designer.setCanvasScale(num);
              }

            }} ></SelectDropdown></div>
            <div></div>

      {/* <button
      onClick={
        ()=>{
          window.open(designer.getPreviewLink(),"_blank")
        }
      }

      >New Tab</button> */}

      <button
        //  {...CreateToolTip("Undo",true)}
        className={"invisible-button undo-redo"}
        disabled = {(designer.undoStates.length<=1)}
        onClick={() => designer.undo()}
      >
        <UndoIcon />
        <HoverToolTip text="Undo" />
      </button>
      <button
        className="invisible-button undo-redo"
        disabled = {(designer.redoStates.length<=0)}
        //  {...CreateToolTip("Redo",true)}
        onClick={() => designer.redo()}
      >
        <RedoIcon />
        <HoverToolTip text="Redo" />
      </button>
      <div className="flex-row row-gap-small" >
        {saveIcon}
        <span style={{ color: saveColor, userSelect: "none" }}>{saveText}    {saveState == SaveState.Error && <HoverToolTip text={"Check internet connection"} />}</span>

      </div>
      <div></div>
      {canModify&&
      <PublishButton

       designer={designer}
        toggleLoading={designer.toggleLoading}
        isDisabled={saveState == SaveState.InProgress || designer.state.layout.children.length < 2}
        isPublished={designer.published && saveState == SaveState.Success}
          onPublish={() => designer.tryPublishPage(false)}
          onSharePreview={() => designer.tryPublishPage(false,true)}
        siteData={designer.props.siteData}
        onPreview={()=>{designer.switchToEditorState(EditorState.Preview)}}
        onSave={() => {
          designer.trySavePage(true);
        }}
      />
    }
      {/* <button
        className="invisible-button"
        disabled= {designer.state.layout.children.length<2}
        onClick={() => designer.switchToEditorState(EditorState.Preview)}
      >
        {" "}
        <PreviewExternalIcon />
        <HoverToolTip text="Preview" />
      </button> */}
    </div>
  );
}

function UndoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="#333"
      style={{ marginBottom: "6px" }}
    >
      <path d="M15.5 9.71875V13.2344C15.5 13.6445 15.1777 13.9375 14.7969 13.9375C14.3867 13.9375 14.0938 13.6445 14.0938 13.2637V9.77734C14.0938 8.10742 12.7168 6.75977 11.0469 6.75977H3.07812L6.79883 9.98242C7.0918 10.2461 7.12109 10.6855 6.88672 10.9785C6.74023 11.0664 6.53516 11.125 6.35938 11.125C6.18359 11.125 6.00781 11.0957 5.89062 10.9785L0.734375 6.55469C0.587891 6.37891 0.5 6.17383 0.5 5.96875C0.5 5.76367 0.587891 5.58789 0.734375 5.44141L5.89062 1.01758C6.1543 0.783203 6.62305 0.8125 6.88672 1.10547C7.12109 1.39844 7.0918 1.83789 6.79883 2.10156L3.07812 5.26562H11.0469C13.4785 5.26562 15.5 7.28711 15.5 9.71875Z" />
    </svg>
  );
}

function RedoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="#333"
      style={{ marginBottom: "6px" }}
    >
      <path d="M4.95312 5.26562H12.8926L9.17188 2.07227C8.87891 1.80859 8.84961 1.36914 9.08398 1.07617C9.34766 0.783203 9.78711 0.753906 10.0801 0.988281L15.2363 5.41211C15.3828 5.58789 15.5 5.76367 15.5 5.96875C15.5 6.17383 15.3828 6.37891 15.2363 6.52539L10.0801 10.9492C9.96289 11.0664 9.78711 11.125 9.64062 11.125C9.43555 11.125 9.23047 11.0371 9.08398 10.8613C8.84961 10.5684 8.87891 10.1289 9.17188 9.86523L12.8926 6.67188H4.95312C3.25391 6.67188 1.90625 8.01953 1.90625 9.68945V13.1758C1.90625 13.6445 1.58398 13.9375 1.20312 13.9375C0.792969 13.9375 0.5 13.6445 0.5 13.2344V9.74805C0.5 7.28711 2.49219 5.26562 4.95312 5.26562Z" />
    </svg>
  );
}

function SavedSuccesfullIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="16"
      fill="#3E8438"
      viewBox="0 0 512 512"
    >
      <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209l17-17L352 158.1l-17 17-111 111-47-47-17-17L126.1 256l17 17 64 64 17 17 17-17L369 209z" />
    </svg>
  );
}

function SavedErrorIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 640 512" fill="rgb(180, 35, 24)">
      <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L364.6 260.4c39.2 7.9 74.7 26.1 103.6 51.6c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192c-13.3 0-26.5 .9-39.3 2.7l-95.1-74.5C227.4 104.5 272.7 96 320 96c103.2 0 196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32c-68.7 0-133.7 15.5-191.9 43.1L38.8 5.1zM93.6 169.8L41.7 128.9C30.7 137.7 20 147 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9c12.4-11.9 25.6-23 39.5-33.1zM228 275.7L173 232.3c-15.5 9.2-30.1 19.8-43.5 31.7c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c16.7-14.8 35.6-27 56.2-36.3zM320 352c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-7-1.1-13.7-3.2-20l-55.6-43.8c-1.7-.1-3.4-.2-5.2-.2z" />
    </svg>
  );
}

function SaveInProgressIcon() {
  return (
    <div className="saving-icon">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}

function PreviewExternalIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 512 512"
      fill="#333"
    >
      <path d="M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z" />
    </svg>
  );
}

// const buttonDropDownStyle = { padding: "12px 4px" };

function PublishButton({
  onPublish,
  onSharePreview,
  isDisabled,
  onSave,
  onPreview,
  siteData,
  isPublished,
  toggleLoading,
  designer
}: {
  isPublished?: boolean;
  isDisabled: boolean;
  toggleLoading: Function;
  onSharePreview:Function;
  onPreview:Function;
  siteData: SiteData;
  designer: WebDesigner;
  onPublish: () => void;
  onSave: () => void;
}) {




  const [menuOpen, setMenuState] = useState(false);
  const ref = React.useRef(null);
  const closeMenu = () => setMenuState(false);
  // const openMenu = () => setMenuState(true);
  const toggleMenu = () => setMenuState(!menuOpen);
  const checkIfClickedOutside = (e: any) => {
    // If the menu is open and the clicked target is not within the menu,
    if (
      menuOpen &&
      ref.current &&
      e.target != null &&
      !(ref.current as Node).contains(e.target as Node)
    ) {
      closeMenu();
    }
  };
  useEffect(() => {
    document.addEventListener("click", checkIfClickedOutside);
    return () => {
      document.removeEventListener("click", checkIfClickedOutside);
    };
  });

  const userContext = siteData.userContext;


  const onSaveLayoutPopup = (onSave:Function) => {
    return ReactDom.render(
      <AddEditlayoutPopup
        LayoutID={userContext.layoutId}
        UserType={userContext.userType}
        CDNURL={userContext.cdnURL}
        access_token={userContext.accessToken}
        isDuplicate={true}
        isBuilderPage={true}
        setLoading={toggleLoading}
        allLayoutName={allLayoutName}
        dispatch={dispatch}
      />,
      document.getElementById("OpenDialog")
    );
  };

  const VagaroAPIEnum = {
    GetStyleCategorySubCategory: "style/getstylecategorysubcategory",
    activatedeactivewebsitebuilder: userContext.businessId + "/domainprocess/activatedeactivewebsitebuilder",
    GetAllStyleName: "style/getallstylename",
    GetAllLayoutName: "layout/getalllayoutname",
  };

  useEffect(() => {
    GetAllStyleName();
    GetAllLayoutName();
//eslint-disable-next-line
  },[]);

  const [allStyleName, setAllStyleName] = useState([]);
  const [allLayoutName, setAllLayoutName] = useState([]);

  const GetAllStyleName = async () => {
    if (utils.Validate(userContext.accessToken)) {
      await AsyncAjaxGet(
        VagaroAPIEnum.GetAllStyleName,
        userContext.accessToken,
        function onSuccess(data: any) {
          try {
            if (
              data != null &&
              data.data != null &&
              data.data.responseCode == ResponseCode.Success
            ) {
              if (
                data != null &&
                data.data != null &&
                data.data.data != null
              ) {
                setAllStyleName(data.data.data);
              } else {
                setAllStyleName([]);
              }
            }
          } catch (error) { }
        },
        function OnError() { }
      );
    }
  };

  const GetAllLayoutName = async () => {
    if (utils.Validate(userContext.accessToken)) {
      await AsyncAjaxGet(
        VagaroAPIEnum.GetAllLayoutName,
        userContext.accessToken,
        function onSuccess(data: any) {
          try {
            if (
              data != null &&
              data.data != null &&
              data.data.responseCode == ResponseCode.Success
            ) {
              if (
                data != null &&
                data.data != null &&
                data.data.data != null
              ) {
                setAllLayoutName(data.data.data);
              } else {
                setAllLayoutName([]);
              }
            }
          } catch (error) { }
        },
        function OnError() { }
      );
    }
  };

  const onSaveStylePopup = (onSave:Function) => {

    return ReactDom.render(
      <AddEditStylePopup
        StyleID={userContext.styleId}
        UserType={userContext.userType}
        CDNURL={userContext.cdnURL}
        dispatch={dispatch}
        isDuplicate={true}
        isBuilderPage={true}
        allStyleName={allStyleName}
      />,
      document.getElementById("OpenDialog")
    );
  };

  const dispatch = useDispatch();

  const { IsNewCustomWebSite, ReactBusinessId, CurrencySymbol, NewCustomizedWebsitePrice, CountryID, BuildInDomain, VagaroURL, AmplitudeBusinessID, IsMutipleLocation, LocationCount, TotalLocationCount  } = useSelector((state: any) => state.Business);

  const ActivateDeactiveWebsiteBuilder = async () => {
    var logobject: any = {};
    logobject.PageURL = window.location.href;
    logobject.Step = 25;
    logobject.UserAgent = (navigator.userAgent).toLowerCase();
    logobject.UserID = userContext.userId;
    logobject.BusinessID = AmplitudeBusinessID;
    logobject.MySiteURL = BuildInDomain+"/"+VagaroURL;
    logobject.CountryID = CountryID;
    logobject.accessToken = userContext.accessToken;

    await AddLogInAmplitude(logobject);
    let data;
    data = {
      isnewcustomwebsite: true,
      userId: userContext.userId,
    };
    await AsyncAjaxPost(
      VagaroAPIEnum.activatedeactivewebsitebuilder,
      data,
      userContext.accessToken,
      function onSuccess(data: any) {
        try {
          if (
            data != null &&
            data.data != null &&
            data.data.responseCode == ResponseCode.Success
          ) {
            if (data != null && data.data != null && data.data.data != null && data.data.data.status) {
              dispatch(ActivateWB({ type: "activate" }));

              onPublish();
              PopupSecondClose();
              AmplitudeAfterPublish();
            }
            else {

            }
          }
        }
        catch (error) {

        }
      },
      function OnError() {

      }
    )
  }

  const PopupSecondClose = () => {
    let dom = document.getElementById("OpenDialog2");
    if (dom) unmountComponentAtNode(dom);
  };

  const AmplitudeAfterPublish = async () => {
    var logobject: any = {};
    logobject.PageURL = window.location.href;
    logobject.Step = 26;
    logobject.UserAgent = (navigator.userAgent).toLowerCase();
    logobject.UserID = userContext.userId;
    logobject.BusinessID = AmplitudeBusinessID;
    logobject.MySiteURL = siteData.vagaroURL;
    logobject.CountryID = CountryID;
    logobject.accessToken = userContext.accessToken;

    await AddLogInAmplitude(logobject);
  };


  const ActivateWebsiteBuilderPopup = async () => {
    return ReactDom.render(
      <VGPopUp
        id={"ActivateWebsiteBuilderPopup"}
        show={true}
        onHide={PopupSecondClose}
        title={"Upgrade to  New Website Builder to Publish"}
        dialogClassName="cancelauto-renew-alert"
        body={
          <div className="alertContent">
            <p>
              Upgrade your website builder to {CurrencySymbol}{NewCustomizedWebsitePrice}/mo to get access to the builder's full functionality and publish your website live.
            </p>
          </div>
        }
        footer={
          <Fragment>
            <button className="w-button w-button-secondary" onClick={() => PopupSecondClose()}>Cancel</button>
            <button className="w-button w-button-primary" onClick={() => { ActivateDeactiveWebsiteBuilder(); }}>Upgrade {CurrencySymbol}{NewCustomizedWebsitePrice}/mo</button>
          </Fragment >
        }
        isRemoveTabModalIndex={false}
        isShowFooter={true}
        size={"md"}
        backdrop={true}
      />,
      document.getElementById("OpenDialog2")
    );
  }

  const onLoadingProgress = (flag:boolean) =>{
      designer.toggleLoading(flag);
  }


  const ActivateMultilocationBusinessPopup = (even:any) => {
    even.preventDefault();
    even.stopPropagation();
    return ReactDom.render(
      <Multilocation Mode={2} ActivateDeactiveWebsiteBuilder={ActivateDeactiveWebsiteBuilder}  dispatch={dispatch} onLoading={onLoadingProgress} />,
        document.getElementById("OpenDialog2")
    )
  }

  const publishText = designer.state.mode == EditorMode.Blogging ? "Publish Post" : "Publish";

  const isBlogging = (designer.state.mode == EditorMode.Blogging)

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <Fragment>
        <button
          className={"publish-button"+(designer.state.mode == EditorMode.Blogging?" blogging":"")}
          onClick={toggleMenu}
          disabled={isDisabled}
        >
          {publishText} &nbsp;&nbsp; <PublishButtonCarretIcon />{" "}
        </button>
      </Fragment>

      {menuOpen && (
        <div
          onClick={() => {
            setMenuState(false);
          }}
          className="publish-menu flex-column"
          style={{
            borderRadius: "4px",
            position: "absolute",
            top: "calc(100% + 1px)",
            padding: "6px 0px",
            right: "0",
            minWidth: "100%",
            boxShadow: "-1px 3px 10px -5px black",
            whiteSpace: "nowrap",
            zIndex: "100",
            background: "white",
          }}
        >
          {
            <>
            {!siteData.editorSettings.autoSave &&
         <button
                disabled={isDisabled}
                className="publish-button nested"
                onClick={() => {
                  onSave();

                }}
              >
                Save
              </button>
}
              <button
                disabled={isDisabled}
                className="publish-button nested"
                onClick={(e) => {
                  IsNewCustomWebSite == false && ReactBusinessId > 0
                    ? (IsMutipleLocation == true && (MultiLocationLive || designer.props.siteData.userContext.userType === LoginUserType.VagaroAdmin) ? ActivateMultilocationBusinessPopup(e) : ActivateWebsiteBuilderPopup())
                    : onPublish();
                }}
              >
                <div className="flex-row justify-between gap-large w-full" style={{ paddingTop: "4px" }}>
                    <div className="flex-column">
                      <div style={{textAlign:"left"}}> {(isBlogging?"Publish Post":"Publish")}</div>
                      {IsMutipleLocation == true && (MultiLocationLive || designer.props.siteData.userContext.userType === LoginUserType.VagaroAdmin) && !isBlogging &&
                        <div className="flex-row justify-start font-small">{LocationCount > 0 &&  (TotalLocationCount > 0 && TotalLocationCount == LocationCount ? <span style={{ opacity: ".7",marginTop:"3px" }}> All Locations</span>  : (LocationCount == 1 ? LocationCount + " Location" : LocationCount + " Locations"))} &nbsp;{IsMutipleLocation && TotalLocationCount > 0 && TotalLocationCount != LocationCount &&
                            <button
                              className="invisible-button justify-start font-small"
                              style={{ opacity: ".7",marginTop:"3px", textDecoration:"none" }}
                              onClick={(e) => ActivateMultilocationBusinessPopup(e)}
                            >
                              Add More Locations
                            </button>

                        }</div>
                      }
                    </div>

                    <PreviewExternalIcon />
                  </div>
              </button>

              <button
                className="publish-button nested"
                onClick={() => {
                  onPreview();
                }}
              >
                Preview
              </button>

              {!siteData.userContext.isAdmin && siteData.userContext.userType === LoginUserType.VagaroAdmin && !isBlogging &&(
                <button
                  className="publish-button nested"
                  onClick={() => {

                    onSharePreview();

                  }}
                >
                  <div className="flex-row justify-between gap-large w-full" style={{ paddingTop: "4px" }}>

                      <div>Share Preview Link</div>


                    <PreviewExternalIcon />
                  </div>
                </button>
              )}

              {siteData.vagaroURL && siteData.lastPublishDate.length > 2 && !isBlogging &&  (
                <button
                  className="publish-button nested"
                  onClick={() => {
                    let siteURL = "https://" + siteData.vagaroURL ;

                    window.open(siteURL, "_blank");
                  }}
                >
                  <div className="flex-row justify-between gap-large w-full" style={{ paddingTop: "4px" }}>
                    <div className="flex-column">
                      <div>{siteData.vagaroURL ?? "open site"}</div>

                      <div
                        className="flex-row justify-start font-small"
                        style={{ opacity: ".7",marginTop:"4px" }}
                      >
                        {"Published " +
                          GetLastPublishString(siteData.lastPublishDate)}
                      </div>
                    </div>

                    <PreviewExternalIcon />
                  </div>
                </button>
              )}
            {isBlogging &&<>
                          <button
                          className="publish-button nested"
                          onClick={() =>
                            OpenSchedulePublishPopup((date:Date)=>{
                              designer.tryPublishBlogPost(date);

                            },()=>{})
                          }
                        >
                          Schedule
                        </button>
                       {designer.state.postInfo && designer.state.postInfo.status == BlogPostStatus.Published &&
                       <>
                        <button
                          className="publish-button nested"
                          onClick={() => {

                            let info = designer.state.postInfo;


                            ArchivePost(designer.props.siteData.userContext,info.id,()=>{
                              Toast("Post Archived")
                              info.isArchive = true;
                            },()=>{
                              info.status = BlogPostStatus.Published;
                              AlertConfirm("Error","Failed to archive post, please try again later.");

                            });

                          }}

                        >
                          Archive
                        </button>
                        <a
                          onClick={(e) => {
                            //kludge to make sure tracking does not interfere with the link
                            let targ = e.target as HTMLAnchorElement;
                            targ.setAttribute("href", "https://"+designer.props.siteData.vagaroURL+ "/blog-post/"+designer.state.postInfo.slug);

                          }}
                          className="publish-button nested no-a flex-row  w-full gap-med"
                          style={{justifyContent:"space-between"}}
                          target="_blank"
                          rel="noreferrer"
                          href={"https://"+designer.props.siteData.vagaroURL+ "/blog-post/"+designer.state.postInfo.slug}

                        >
                         <div> Open Post</div>

                          <PreviewExternalIcon />
                        </a>
                        </>
}

                        </>

            }
              {userContext.userType == LoginUserType.VagaroAdmin && !isBlogging && (
                <>
                  <hr style={{ margin: "4px" }} />
                  <button
                    className="publish-button nested"
                    onClick={() =>
                      onSaveStylePopup(() => {
                        designer.saveType = SaveType.Style;
                      })
                    }
                  >
                    Save as Style
                  </button>
                  <button
                    className="publish-button nested"
                    onClick={() =>
                      onSaveLayoutPopup(() => {
                        designer.saveType = SaveType.Layout;
                      })
                    }
                  >
                    Save as Layout
                  </button>

                </>
              )}

            {!siteData.userContext.isAdmin&&!isBlogging&&
                              <button
                                className="publish-button nested"
                                onClick={() =>{

                                  designer.toggleLoading(true);

                                  designer.saveCurrentPageAsync(()=>{

                                  SaveHistory(designer.props.siteData.userContext,()=>{
                                    designer.toggleLoading(false);
                                    Toast("Successfully saved to version history.");
                                  },()=>{
                                    designer.toggleLoading(false)});
                                });

                                }}
                              >
                                Save to Version History
                              </button>
            }
            </>
          }
        </div>
      )}
    </div>
  );
}

function LayoutIcon() {

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="#333"><path d="M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z" /></svg>
}


function LayoutIconChecked() {

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="#3E8438" >
    <path d="M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64z" /></svg>
}


function GetLastPublishString(datestring:string){

  let num = parseInt(datestring);
  if(isNaN(num)){
    return ""
  }

  let dif = new Date().getTime() - num;

  let sec = dif/1000;
  let min = sec/60;
  let hour = min/60;
  let day = hour/24;
  let week = day/7;
  let month = week/4;
  let year = month/12;

  if (min < 1) {
    return "less than a minute ago";
  } else if (hour < 1) {
    return Math.floor(min) + " min ago";
  } else if (day < 1) {
    if (hour >= 2) return Math.floor(hour) + " hrs ago";
    else return "1 hr ago";
  } else if (week < 1) {
    if (day >= 2) return Math.floor(day) + " days ago";
    else return "1 day ago";
  } else if (month < 1) {
    if (week >= 2) return Math.floor(week) + " weeks ago";
    else return "1 week ago";
  } else if (year < 1) {
    if (month >= 2) return Math.floor(month) + " months ago";
    else {
      return "1 month ago";
    }
  } else {
    if (year >= 2) return Math.floor(year) + " years ago";
    else return "1 year ago";
  }

}


function PublishButtonCarretIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 512"
      height="14"
      width="8"
      fill="#fff"
    >
      <path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z" />
    </svg>
  );
}

function UnsavedIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="16"
      fill="currentColor"
      viewBox="0 0 512 512"
    >
      <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" />
    </svg>
  );
}





function OpenSchedulePublishPopup(onApply:(date:Date)=>void,onDismiss:()=>void){
  const now = new Date();

  // Format to "YYYY-MM-DDTHH:MM" (local time)
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');

  // Combine into the correct format
  const localDatetime = `${year}-${month}-${day}T${hours}:${minutes}`;




  const PopupClose = () => {
    let dom = document.getElementById("OpenDialog");
    if (dom) unmountComponentAtNode(dom);

    };

    return ReactDom.render(
      <VGPopUp
        id={"schedule-publish-popup"}
        show={true}
        onHide={()=>{PopupClose();onDismiss()}}
        title={"Schedule Publish"}
        dialogClassName="block-edit"
        body={
          <div className="alertContent">
            <input
            id='schedule-publish-date'
            className="w-full"
            style={{
              padding:"10px",
              letterSpacing:"1px",
              border:"1px solid #ccc",
              borderRadius:"4px",
            }}
            type="datetime-local"  name="schedule-publish-date"
            defaultValue={localDatetime}
            />
          </div>
        }
        footer={
          <Fragment>
             <button className="w-button w-button-secondary" onClick={() => {PopupClose(); onDismiss();}}>{"Cancel"}</button>
             <button className="w-button w-button-primary" onClick={() => {
                onApply(new Date((document.getElementById('schedule-publish-date') as HTMLInputElement).value));PopupClose();
             }}>{"Schedule"}</button>

          </Fragment >
        }
        isRemoveTabModalIndex={false}
        isShowFooter={true}
        size={"modal-sm"}
        backdrop={true}
      />,
      document.getElementById("OpenDialog"));

}